import React, { useState } from 'react';
import './CalculatorPage.css';

function MobileNumberAnalysis() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzeNumber = (number) => {
    // Placeholder for Mobile Number Analysis logic
    // This is a simplified example; real analysis would be more complex.
    if (!number) return null;
    const digits = number.replace(/\D/g, '');
    if (digits.length < 10) return "Please enter a valid 10-digit phone number.";

    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += parseInt(digits[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    return `The numerological value of your mobile number is ${sum}. This is a placeholder explanation for mobile number analysis.`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!mobileNumber) {
      setError('Please enter a mobile number.');
      return;
    }

    const calculated = analyzeNumber(mobileNumber);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Mobile Number Analysis",
    "description": "Analyze your mobile number for numerological insights and its impact on your life.",
    "url": "https://www.yourwebsite.com/mobile-number-analysis",
    "potentialAction": {
      "@type": "AnalyzeAction",
      "name": "Analyze Mobile Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/mobile-number-analysis?number={mobileNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=mobileNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Mobile Number Analysis</h1>
      <p className="text-center">Enter your mobile number to get a numerological analysis.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="mobileNumber">Mobile Number:</label>
          <input
            type="text"
            id="mobileNumber"
            className="form-control"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="e.g., 9876543210"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Analysis:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default MobileNumberAnalysis;
